import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as todoAction from './store/Submit.action';
import { checkArray, Page_Size, shortenStringWithTooltip, hideImage, showBigImage } from '../../../../Components/helper';
import noImage from '../../../../assets/images/no-image.png';
import '../Todo.css';
import Loader from '../../../../Components/Utility/Loader/Loader';

function List({ loading, mappedArray }) {
  const [state, setState] = useState({
    submitList: [],
    hasMore: true,
    loading: false,
    selectedIdsArray: [],
    isSelectAll: false,
    selectedColumn: [],
  });
  const { t } = useTranslation('common');

  const { submitList, selectedColumn, selectedIdsArray, isSelectAll } = state;

  useEffect(() => {
    const dat = mappedArray.sort((a, b) => a.value - b.value);
    setState((prev) => ({
      ...prev,
      selectedColumn: dat,
    }));
  }, [mappedArray]);
  const {
    submitTodoListReducer: {
      submitListData,
      submitFilterValues: {
        searchText,
        selected_Season,
        selected_Brand,
        selected_Supplier,
        selected_Category1,
        selected_Category2,
        selected_Category3,
        selected_Category4,
        selected_Status,
        sortOrder,
        sortPropertyName,
        selected_Send_To,
        selected_DownloadBy,
        selected_SendBy,
        selected_Submitted,
        selected_Month,
        selected_Year,
      },
    },
    Users: { moduleAccess },
  } = useSelector((reduxState) => reduxState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Array.isArray(submitListData)) {
      setState((prevState) => ({
        ...prevState,
        submitList: submitListData,
      }));
    }
  }, [submitListData]);

  const headerSortingIcon = (lable, propertyName, _orderType) => {
    return (
      <span className="cursor-pointer">
        {lable}
        {sortPropertyName === propertyName ? (
          <>
            {sortOrder === '' && <i className="fa fa fa-sort ml-1" />}
            {sortOrder === 'Asc' && <i className="fa fa fa-sort-up ml-1" />}
            {sortOrder === 'Desc' && <i className="fa fa fa-sort-desc ml-1" />}
          </>
        ) : (
          <i className="fa fa fa-sort ml-1" />
        )}
      </span>
    );
  };

  const onSortColumn = async (propertyName) => {
    if (sortOrder === '' || sortOrder === 'Desc') {
      const sortObj = {
        seasons: selected_Season,
        brand: selected_Brand,
        supplier: selected_Supplier,
        category1: selected_Category1,
        category2: selected_Category2,
        category3: selected_Category3,
        category4: selected_Category4,
        status: selected_Status,
        type: 'submit-download',
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize: Page_Size,
        sendTo: selected_Send_To,
        downloadBy: selected_DownloadBy,
        sendBy: selected_SendBy,
        sendBy1: selected_Submitted,
        month: selected_Month,
        year: selected_Year,
      };
      const obj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
      await dispatch(todoAction.getSubmitList(sortObj));
    } else {
      const sortObj = {
        sortOrder: 'Desc',
        seasons: selected_Season,
        brand: selected_Brand,
        supplier: selected_Supplier,
        category1: selected_Category1,
        category2: selected_Category2,
        category3: selected_Category3,
        category4: selected_Category4,
        type: 'submit-download',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize: Page_Size,
        status: selected_Status,
        sendTo: selected_Send_To,
        downloadBy: selected_DownloadBy,
        sendBy: selected_SendBy,
        sendBy1: selected_Submitted,
        month: selected_Month,
        year: selected_Year,
      };
      await dispatch(todoAction.getSubmitList(sortObj));
      const obj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
    }
  };

  const handleSelection = (id) => {
    let selectIds = [...selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = submitListData.map((ele) => ele._id);
    } else if (id) {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== submitListData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === submitListData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
    dispatch(todoAction.setSelectedIds(selectIds));
  };
  useEffect(() => {
    dispatch(todoAction.setSelectedIds(selectedIdsArray));
  }, [selectedIdsArray]);

  const getSentUsers = (sentArray) => {
    const filteredSentArray = sentArray.filter((user) => ![null, undefined, ''].includes(user));
    if (filteredSentArray && filteredSentArray.length === 1) {
      return filteredSentArray[0];
    }
    if (filteredSentArray && filteredSentArray.length > 1) {
      return (
        <div className="info-container d-inline-flex align-items-center text-left">
          {t('TAKING_DATES.MULTIPLE')} <span className="icon-info f-18 ml-1" />
          <div className="info-content">
            <p className="m-1 mb-1">{filteredSentArray.join(',')}</p>
          </div>
        </div>
      );
    }
    return '--';
  };
  const getDownloadUsers = (sentArray) => {
    if (sentArray && sentArray.length === 1) {
      return (
        <div>
          <p className="mb-1">{sentArray[0].email}</p>
          <p className="mb-1">{moment(sentArray[0].date).format('DD-MMMM-YYYY, h:mm a')}</p>
        </div>
      );
    }
    if (sentArray && sentArray.length > 1) {
      return (
        <div className="info-container d-inline-flex text-left">
          {t('TAKING_DATES.MULTIPLE')} <span className="icon-info f-18 ml-1" />
          <div className="info-content">
            {sentArray.map((item, idx) => (
              <p className="mb-0" key={idx}>
                {item.email} {moment(item.date).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            ))}
          </div>
        </div>
      );
    }
    return '--';
  };

  return (
    <table id="progressList" className="table custom-table layout-fixed font-13 text-center todo-fixed-col-table customTable  fixed-col-table-submit ">
      <thead>
        <tr>
          <th className="w-80px w-xs-40px">
            <div className="checkbox-label no-label margin-auto">
              <input
                type="checkbox"
                onChange={(e) => handleSelection(e.target.checked)}
                name="check_all_samples"
                id="check_all_samples"
                checked={isSelectAll}
                disabled={!submitListData.length}
              />
              <label htmlFor="check_all_samples" className="chklabel">
                <span />
              </label>
            </div>
          </th>
          <th className="w-80px" />
          <th className="last-fix-col w-150px" onClick={() => onSortColumn('number')}>
            {headerSortingIcon(t('TABLE_HEADERS_LIST.PRODUCT_REF'), t('TABLE_HEADERS_LIST.NUMBER'), t('TABLE_HEADERS.ASC'))}
          </th>
          {selectedColumn.map((da, idx) => (
            <th key={idx} className={da.label === 'Product Description' ? 'w-150px' : 'w-100px'} onClick={() => onSortColumn(da.display)}>
              {headerSortingIcon(da.label, da.display, 'Asc')}
            </th>
          ))}

          <th className="w-150px">{t('TAKING_DATES.FROMS')}</th>
          <th className="w-150px">{t('TAKING_DATES.TO_')}</th>
          <th className="w-150px">{t('PURCHASE_ORDER_NUMBER.FILES')}</th>
          <th className="w-150px">{t('TAKING_DATES.SUBMITTED')}</th>
          <th className="w-150px">{t('TAKING_DATES.DOWNLOADED')}</th>
        </tr>
      </thead>
      <tbody>
        {checkArray(submitList) &&
          submitList.map((data, idx) => (
            <tr key={idx}>
              <td>
                <div className="checkbox-label no-label margin-auto">
                  <input
                    onChange={() => {
                      handleSelection(data?._id);
                    }}
                    name={`checks_${idx}`}
                    id={`checks_${idx}`}
                    type="checkbox"
                    checked={selectedIdsArray.filter((val) => val === data?._id).length > 0}
                  />
                  <label htmlFor={`checks_${idx}`} className="chklabel">
                    <span />
                  </label>
                </div>
              </td>
              <td>
                <div className="image-detail hover-right">
                  <figure className="d-inline-block m-0" onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                    <div className="img-preview-inside-table sm">
                      <img width="60" alt="product img" src={data?.image || noImage} />
                    </div>
                  </figure>
                </div>
              </td>
              <td className="last-fix-col">
                {data?.number}
                {moduleAccess?.productsAccess && (
                  <Link 
                    className="cursor-pointer text-dark text-decoration-none" 
                    to={`/development-order/${data?.devOrderId}/submit-download`}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <i className="icon-detail_page pl-1 text-dark" />
                  </Link>
                )}
              </td>
              {selectedColumn.map((da) => {
                const eleKey = da;
                return (
                  <td key={eleKey} className="w-50px">
                    {shortenStringWithTooltip(data[da.display], 30) || '--'}
                  </td>
                );
              })}

              <td>
                <div className="d-flex align-items-center">
                  <div className="text-left pr-2">
                    <p className="mb-0">{data?.sendBy}</p>
                    <p className="mb-0"> {moment(data?.createdAt).format('DD-MMMM-YYYY hh:mm A')}</p>
                  </div>
                  {data?.message && (
                    <OverlayTrigger
                      placement={t('TABLE_HEADERS_LIST.BUTTON')}
                      overlay={
                        <Tooltip className="text-tooltip" id="tooltip_description">
                          {data.message}
                        </Tooltip>
                      }
                    >
                      <span className="icon-Chat f-18 ml-1" />
                    </OverlayTrigger>
                  )}
                </div>
              </td>
              <td>{getSentUsers(data?.sentUsers)} </td>
              <td>{data?.files.length > 0 ? data?.files[0]?.filename : '--'} </td>
              <td>
                <p className="mb-0">{data?.sendBy}</p>
                <p className="mb-0"> {moment(data?.createdAt).format('DD-MMMM-YYYY hh:mm A')} </p>
              </td>
              <td>{getDownloadUsers(data?.downloadByEmails)}</td>
            </tr>
          ))}

        {loading && (
          <tr>
            <td colSpan={selectedColumn?.length + 8}>
              <Loader />
            </td>
          </tr>
        )}

        {isEmpty(submitList) && !loading && (
          <tr>
            <td />
            <td colSpan={selectedColumn?.length + 6}>
              <span className="d-flex align-items-center justify-content-center">{t('PROGRESS_INDICATOR.NO_PRODUCT')}</span>
            </td>
            <td />
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default List;
